"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var schemaMethods_1 = require("../schemaMethods");
var validationMessages_1 = require("../validationMessages");
/**
 * domyslne opcje schematu
 */
exports.defaultOptions = {
    Vue: null,
    resetOnFocus: true,
    dirtyOnInput: false,
    dirtyOnBlur: true,
    disableCalculations: false,
    disableValidations: false,
    startDirty: false,
    schemaMethods: schemaMethods_1.default,
    wrapAll: false,
    fixData: true,
    validationMessages: validationMessages_1.default,
    warningMessages: validationMessages_1.default,
    form: {},
    external: {},
    disabledFields: {}
};
/**
 * łączenie opcji z opcjami domyslnymi
 *
 * @export
 * @param {*} [options]
 * @returns {IOptions}
 */
function fixSchemaOptions(options) {
    if (options) {
        return Object.assign({}, exports.defaultOptions, options);
    }
    else {
        return Object.assign({}, exports.defaultOptions);
    }
}
exports.fixSchemaOptions = fixSchemaOptions;
/**
 * dołaczanie opcji *
 * @export
 * @param {IOptions} options
 * @param {IOptions} optionsToMerge
 */
function mergeOptions(options, optionsToMerge) {
    for (var key in optionsToMerge) {
        if (optionsToMerge.hasOwnProperty(key)) {
            var value = optionsToMerge[key];
            if (typeof value === 'object') {
                if (options[key] === undefined) {
                    options[key] = {};
                }
                mergeOptions(options[key], value);
            }
            else {
                options[key] = optionsToMerge[key];
            }
        }
    }
}
exports.mergeOptions = mergeOptions;
//# sourceMappingURL=IOptions.js.map